import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    reload: false
}

const reload = createSlice({
    name: "reload",
    initialState,
    reducers: {
        reloadToggle: (state) => {
            state.reload = !state.reload
        }
    }
})

export const {reloadToggle} = reload.actions
export default reload.reducer